import beach from '../assets/news/beach.jpg';
import damen from '../assets/news/damen.jpg';
import herren from '../assets/news/herren.jpg';
import jugend from '../assets/news/jugend.jpg';
import {CATEGORY} from '../config';
import {Article} from '../types';

/** Stock pictures by category, for posts without a featured image. */
const FALLBACK_IMAGES: [number[], string][] = [
    [[CATEGORY.damen1, CATEGORY.damen2], damen],
    [[CATEGORY.herren1, CATEGORY.herren2], herren],
    [[CATEGORY.jugend], jugend],
    [[CATEGORY.beach], beach],
];

export const articleImage = (article: Article) =>
    article.imageUrl
    ?? FALLBACK_IMAGES.find(([ids]) => ids.some(id => article.categories.includes(id)))?.[1]
    ?? herren;
